<template>
    <div class="box" :class="boxClass">
        <div class="icon">
            <slot></slot>
        </div>
        <div class="label">
            {{ label }}
        </div>
    </div>
</template>

<script>
import { computed, defineComponent } from 'vue';

export default defineComponent({
    props: {
        active: {
            type: Boolean
        },
        label: {
            type: String
        },
        value: {
            type: String
        }
    },
    setup: function (props) {
        const boxClass = computed(() => {
            return {
                'active': props.active
            }
        })

        return {
            boxClass
        }
    }
})
</script>

<style lang="scss" scoped>
.box {
    border-radius: 16px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    background-color: #fff;
    @apply flex flex-col items-center text-center justify-center border-2 border-transparent py-2.5 cursor-pointer;

    &.active {
        @apply border-a-orange-fe5000;
    }

    .icon img{
        @apply h-6 w-6
    }

    .label {
        padding-top: 5px;
        @apply text-a-black-484848 text-10 font-medium;
    }
}
</style>